import React from "react";
import Header from "../header";
import Footer from "../footer";

function MainLayout({ children }) {
  return (
    <main className="main-layout">
      <Header />
      <div className="page--area">
        <div className="max--container">{children}</div>
      </div>
      <Footer />
    </main>
  );
}

export default MainLayout;
